if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form');
            const idInput = this.form.querySelector('[name=id]');
            if (idInput) idInput.disabled = false;

            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.submitButton = this.querySelector('[type="submit"]');

            if (document.querySelector('cart-drawer')) {
                this.submitButton.setAttribute('aria-haspopup', 'dialog');
            }
        }

        onSubmitHandler(evt) {
            evt.preventDefault();
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

            this.handleErrorMessage();

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');

            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json'
                },
                body: new URLSearchParams(new FormData(this.form)).toString(),
                credentials: 'include'
            };

            const url = window.routes?.cart_add_url || '/cart/add.js';

            fetch(url, config)
                .then((response) => {
                    if (response.status === 401) {
                        // If still 401, try to refresh the session or just throw
                        throw new Error('Unauthorized: Please ensure you are logged in to the store preview.');
                    }
                    if (!response.ok) {
                        return response.text().then(text => {
                            throw new Error(`HTTP ${response.status}: ${text}`);
                        });
                    }
                    return response.json();
                })
                .then((response) => {
                    if (response.status) {
                        this.handleErrorMessage(response.description || response.message);
                        return;
                    }

                    // Trigger cart refresh
                    document.dispatchEvent(new CustomEvent('cart:refresh'));

                    // Open cart drawer
                    if (window.cartDrawer) {
                        window.cartDrawer.open();
                    } else {
                        // Fallback if global is not yet init
                        const drawer = document.querySelector('cart-drawer');
                        if (drawer && typeof drawer.open === 'function') drawer.open();
                    }
                })
                .catch((e) => {
                    console.error('Add to cart error:', e);
                    this.handleErrorMessage(e.message);
                })
                .finally(() => {
                    this.submitButton.removeAttribute('aria-disabled');
                    this.submitButton.classList.remove('loading');
                });
        }

        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
            }
        }
    });
}
